import React, { useCallback } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import MuiDrawer from '@material-ui/core/Drawer'

const defaulyAppSidebarWidth = '260px'

const useStyles = props => makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: props.width ? props.width : defaulyAppSidebarWidth,
    flexShrink: 0,
  },
  paper: {
    width: props.width ? props.width : defaulyAppSidebarWidth,
    top: props.top || '0px',
    height: `calc(100% - ${props.top || '0px'})`
  },
  drawerContainer: {
    overflow: 'auto',
  },
  drawerOpen: {
    width: props.width ? props.width : defaulyAppSidebarWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '70px'
  },
}))()

const Drawer = props => {
  const classes = useStyles(props)
  const [open, setOpen] = React.useState(props.defaultOpen)

  const handleDrawerOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleDrawerClose = useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <MuiDrawer
      id='drawer'
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: clsx(classes.paper, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
    >
      <props.drawerContent open={open} handleDrawerClose={handleDrawerClose} handleDrawerOpen={handleDrawerOpen} />
    </MuiDrawer>
  )
}

Drawer.propTypes = {
  defaultOpen: PropTypes.bool,
}

export default Drawer
